import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNumberTileIncomplete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 225,
	viewBox: "0 0 400 225",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .2,
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M169 145.2C169 139.6 173.6 135 179.2 135H214.8C220.4 135 225 139.6 225 145.2V148.8C225 154.4 220.4 159 214.8 159H179.2C173.6 159 169 154.4 169 148.8V145.2Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M84 86.8C84 78.6 90.6 72 98.8 72H294.2C302.4 72 309 78.6 309 86.8V105.2C309 113.4 302.4 120 294.2 120H98.8C90.6 120 84 113.4 84 105.2V86.8Z",
		fill: "white",
		fillOpacity: .5
	})]
});
export default SvgNumberTileIncomplete;
